import { SONHTMLContent } from '../Wysiwyg';
import { UserProfile } from '../../../types/api/UserProfile';
import { IFileItem } from '../../../types/api/FileItem';
import { HiddenParam, SonForm, TextParam } from '../../Form2';
import { AnyParameter } from '../../Form2/types/SonForm';
import { BlockType } from '../../../types/api/ElementType';
import { FileUploadParams } from '../../Form2/types/FileUploadParam';

export type PostFirstTypes = 'comment' | 'thread' | 'feedback';
export type PostTypes = PostFirstTypes | 'reply';

export type PostFormTypes =
  | TextParam<'content'>
  | FileUploadParams<'fileuploadparams'>
  | HiddenParam<'replyTo'>
  | HiddenParam<'postId'>;

// a PostReply is the same as a Post, but it cant have attachments and replies
// export type PostReply = Omit<PostFirst, 'replies' | 'attachments' | 'attachedFileUpdateOrder' | 'replyForm'>;
export type PostReply = SONHTMLContent & {
  id: string;
  createDate: string;
  author: UserProfile;
  updateForm?: SonForm<PostFormTypes>;
  deleteForm?: SonForm<any>;
  editDate?: string;
};
export type PostFirst = PostReply & {
  replyForm: SonForm<any>;
  replies?: PostReply[];
  attachments?: IFileItem[];
  attachedFileUpdateOrder?: SonForm<AnyParameter>;
};

export type PostBlockTypes = BlockType.comments | BlockType.thread | BlockType.threadlist | BlockType.editorFeedback;

export const postType = (
  elementType: BlockType.comments | BlockType.thread | BlockType.threadlist | BlockType.editorFeedback,
) => {
  if (elementType === BlockType.editorFeedback) {
    return 'feedback';
  } else {
    return 'comment';
  }
};

export function isPostFirst(post: PostFirst | PostReply): post is PostFirst {
  const postFirst = post as PostFirst;
  return !!postFirst.replyForm;
}
